import { render, staticRenderFns } from "./SidebarAddPaymentMethod.vue?vue&type=template&id=2723e1c2&"
import script from "./SidebarAddPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./SidebarAddPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports